<template>
	<div class="content">
		<PageHeader></PageHeader>
		
		<div class="breadcrumb">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><router-link to="/">首页</router-link></el-breadcrumb-item>
				<el-breadcrumb-item>活动管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		
		<div class="help-menu">
			<div class="menu-left">
				<el-menu
					:unique-opened="true"
					:default-active="current"
					class="el-menu-vertical-demo"
					active-text-color="#3c78eb"
					@open="handleOpen">
					<el-submenu :index="item.firstIndex" v-for="(item,index) in helpList" :key="index">
						<template slot="title">
							<span>{{item.title}}</span>
						</template>
						<el-menu-item-group>
							<router-link :to="{name: item1.url}" v-for="(item1,index1) in item.menuGroup" :key="index1">
								<el-menu-item :index="item1.itemIndex">
									{{item1.title}}
								</el-menu-item>
							</router-link>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</div>
			<div class="menu-right">
				<router-view></router-view>
			</div>
		</div>
		
		<PageFooter></PageFooter>
	</div>
</template>

<script>
import PageHeader from '@/components/head.vue'
import PageFooter from '@/components/footer.vue'
export default {
	data(){
		return {
			current: '1',
			helpList: [
				{
					title: '交易方式',
					firstIndex: '1',
					menuGroup: [
						{title: '快递回收',itemIndex: '1-1',url:'Express'},
					]
				},
				{
					title: '质检说明',
					firstIndex: '2',
					menuGroup: [
						{title: '质检名词解释',itemIndex: '2-1',url:'Quality'},
						{title: '回收检测流程',itemIndex: '2-2',url:'Process'}
					]
				},
				{
					title: '帮助中心',
					firstIndex: '3',
					menuGroup: [
						{title: '常见问题',itemIndex: '3-1',url:'Problem'},
						{title: '服务条款',itemIndex: '3-2',url:'Serve'},
						{title: '隐私协议',itemIndex: '3-3',url:'Privacy'}
					]
				},
				{
					title: '关于我们',
					firstIndex: '4',
					menuGroup: [
						{title: '公司简介',itemIndex: '4-1',url:'Company'},
					]
				}
			],
		}
	},
	
	components: {
		PageHeader,
		PageFooter
	},
	
	methods:{
		handleOpen(key) {
			this.current = key
		}
	}
}
</script>

<style scoped>
a{
	text-decoration: none;
}

.breadcrumb{
	width: 1226px;
	padding: 20px 0;
	margin: 0 auto;
}

.help-menu{
	width: 1226px;
	margin: 0 auto;
	display: flex;
}

.help-menu .menu-left{
	width: 230px;
	height: 384px;
	background-color: #fff;
	margin-right: 20px;
}

.help-menu .menu-right{
	flex: 1;
	background-color: #fff;
	box-shadow: 0 0 10px 0 rgba(71,71,71,.2);
	padding: 20px 40px 40px;
	margin-bottom: 100px;
}

</style>
